import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, isRef as _isRef, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("解锁")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出社保记录")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("导入社保记录")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("社保异动查询")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("锁定")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("获取建议值")

import tbMix from '@/global_mixin/tableMixin'
import { reactive, ref, Ref, watch, onBeforeMount } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import { getNumber, exportHandle, formatNumber } from '@/utils/index'
import store from '@/store/index'
import eptBtn from '@/components/ExportButton.vue'
import type { TableColumnCtx } from 'element-plus/es/components/table/src/table-column/defaults'
import Api from '@/http/modules/index'
interface SummaryMethodProps<T = any> {
  columns: TableColumnCtx<T>[]
  data: T[]
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/socials/list': fetchList,
  // 获取所有公司
  'GET/company': companyListApi,
  // 获取所有团队
  'GET/organizations': orgListApi,
  // 所有用户
  'GET/users/list': userListApi,
  // 锁定
  'PATCH/socials/lock': socialsLock,
  // 解锁
  'PATCH/socials/unlock': socialsUnlock,
  // 新增社保
  'POST/socials/create': socialsCreateApi,
  // 社保修改(编辑)
  'PATCH/socials': socialsPATCHApi,
  // 建议值(编辑)
  'POST/socials/initialization': proposalVlaueApi,
  // 根据ids删除社保记录（批量删除）
  'DELETE/socials': batchDelApi,
  // 删除
  // 'DELETE/socials/{id}': delSocialFn,
  // 下载湖南公积金模板
  'GET/socials/download/fund_template': SocialsDownloadFund_templateApi,
  // 下载湖南社保模板
  'GET/socials/download/social_template': socialsDownloadSocial_templateApi,
  // 下载社保记录模板
  'POST/socials/download/social': socialsDownloadSocialApi,
  // 社保记录导出
  'POST/socials/export': exportScoialsFn,
  // 湖南公司模板导入
  'POST/socials/import': socialsImportApi,
  // 导入社保记录
  'POST/socials/upload': socialsUploadApi,
  // 锁定(单个)社保
  'POST/socials/locked_single': locked_singleApi,
} = Api

let userOptions = ref([])
let companyOptions = ref([])
onBeforeMount(() => {
  userListApi().then((rep: any) => {
    userOptions.value = rep.map((_user: any) =>{
      _user.name = _user.alias + '(' + _user.realName+ ')'
      return _user
    })
  })

  companyListApi().then((rep: any) => {
    companyOptions.value = rep
  })
})

const insuranceTb = ref()
let { 
  MI_height, MI_tableData, fetchData, page, size, MI_total,
  MI_params, MI_pageChange, MI_sizeChange, MI_modifyForm, MI_identify 
} = new tbMix(fetchList)


let seleRows: any = []
const handleSelectionChange = (val: object[]) => {
  seleRows = val
}

let searchConfig = ref([    
  {
    label: '姓名',
    value: '',
    upKey: 'realName',
    props: {
      placeholder: "请输入姓名"
    }
  },  

  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: orgListApi,
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
    props: { placeholder: '请选择团队', clearable: true }
  },

  {
    type: "TIME",
    label: "停缴日期",
    value: '',
    upKey: 'unPaymentDate',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
  {
    type: 'SELECT',
    label: '锁定',
    value: false,
    upKey: 'locked',
    options:  [
      {label: '未锁定', id: false},
      {label: '锁定', id: true},
    ],
    props: {placeholder: '请选择锁定类型', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: 'SELECT',
    label: '员工类型',
    value: '',
    upKey: 'noFormalEmp',
    options:  [
      {label: '待转正员工', id: '待转正员工'},
    ],
    props: {placeholder: '请选择员工类型', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    }
  },
  {
    type: "TIME",
    label: "缴纳日期",
    value: '',
    upKey: 'payDates',
    upProps: { startKey: 'from', endKey: 'to', },
    props: {
      type: 'daterange',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司",},
    seleProps: { label: "name", valueName: "id", },
  },
])

// 搜索后获得总计
const showTbTotal = ref<boolean>(true)
let totalObj: any = reactive({})
const searchHd = async (params: any) => {
  let rep = await fetchData({
    ...params,
    dateRange:{
      from: params.from,
      to: params.to,
    }
  })
  Object.assign(totalObj, rep.total)
}

// 批量删除
const delHandle = async () => {
  if(seleRows.length < 1){
    ElMessage.warning({message: '请至少选择一条数据', grouping: true})
    return
  }
  try {
    await ElMessageBox.confirm( '请确认是否删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    MI_identify.value = true
    await batchDelApi({socialIds: seleRows.map((_user: any) => _user.id)})
    MI_identify.value = false
    ElMessage.success('删除成功')
    searchHd(MI_params)
    insuranceTb.value.clearSelection()
  } catch (error) {
    MI_identify.value = false
  }
}
// 编辑弹窗
const socialRule: any = [
  { type: 'number', message: '请输入数字' },
  {
    validator: (rule: any, value: any, callback: any) => {
      
      /* if(!value || value === 0){
        callback()
      } else if( value < 0){
        callback(new Error('必须大于0'))
      } else */ 
      if(value && ((value + '').split('.')[0] + '').length > 8) {
        callback(new Error('必须小于8位数'))
      }
      callback()
      
    },
    trigger: 'change'
  }
]
const editEle: any = ref(null)
const socialsVisible = ref<boolean>(false)
let modifyConfig: Ref<FromConfig[]> = ref([
  {
    type: 'NUMBER',
    label: '单位养老保险',
    value: '',
    upKey: 'companyEndowment',
    props: {
      placeholder: "单位养老保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人养老保险',
    value: '',
    upKey: 'personalEndowment',
    props: {
      placeholder: "个人养老保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位医疗保险',
    value: '',
    upKey: 'companyMedical',
    props: {
      placeholder: "单位医疗保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人医疗保险',
    value: '',
    upKey: 'personalMedical',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位工伤保险',
    value: '',
    upKey: 'companyInjury',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人工伤保险',
    value: '',
    upKey: 'personalInjury',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位生育保险',
    value: '',
    upKey: 'companyMaternity',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人生育保险',
    value: '',
    upKey: 'personalMaternity',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位失业保险',
    value: '',
    upKey: 'companyUnemployment',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人失业保险',
    value: '',
    upKey: 'personalUnemployment',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位公积金',
    value: '',
    upKey: 'companyHousing',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人公积金',
    value: '',
    upKey: 'personalHousing',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: "TIME",
    label: "缴纳日期",
    value: '',
    upKey: 'payDate',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    },
    rule: [{ required: true, message: '请选择缴纳日期', trigger: 'change' }],
  },
  {
    type: "SELECT",
    selectType: 'GROUP',
    label: "公司",
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司"},
    seleProps: { label: "name", valueName: "id", },
    rule: [{ required: true, message: '请选择缴公司', trigger: 'change' }],
  },
])
// 弹窗
let currentRow: any = {}
const showEdit = (row: object):void => {
  currentRow = row
  MI_modifyForm(row, modifyConfig ,socialsVisible, async (params: any) => {
    await socialsPATCHApi({...params, id: currentRow.id})
    socialsVisible.value = false
    ElMessage.success('修改成功')
    currentRow = {}
    let rep = await fetchData(MI_params)
    // totalObj = rep.total
    Object.assign(totalObj, rep.total)
  })
}
const proposalHandle = async () => {
  // 获取编辑建议值
  let porpval = await proposalVlaueApi({companyId: currentRow.companyId} as any)
  editEle.value.resetForm()
  Object.assign(editEle.value.dataObj, porpval)
  ElMessage('已填入建议值')
}

// 锁定行
const lockRowHandle = (row: any) => {
  MI_identify.value = true
  locked_singleApi({id: row.id}).then(async () => {
    ElMessage.success('锁定成功')
    MI_identify.value = false
    let rep = await fetchData(MI_params)
    Object.assign(totalObj, rep.total)
  }).finally(() => {
    MI_identify.value = false
  })
}



// 锁定按钮
const lockFg = ref<boolean>(false)
const lockConfig = ref<FromConfig[]>([
  {
    type: "SELECT",
    label: "公司",
    value: "",
    upKey: "companyId",
    rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
    options: companyOptions,
    // selectFunc: companyListApi,
    props: {clearable: true, placeholder: "请选择公司",},
    seleProps: {label: "name",valueName: "id",},
  },
  {
    type: "TIME",
    label: "缴纳日期",
    value: '',
    upKey: 'payDate',
    rule: [{ required: true, message: '必选项', trigger: 'change' }],
    props: {type: 'month', 'value-format': 'YYYY-MM-DD', clearable: true}
  },
])
const openLockHandle = () => {
  lockConfig.value[0].value = MI_params.companyId
  MI_modifyForm({}, lockConfig, lockFg, async (params: any) => {
    await socialsLock(params)
    ElMessage.success('锁定成功')
    lockFg.value = false
    searchHd(MI_params)
  })
}

// 解锁按钮
const unlockFg = ref<boolean>(false)
const unlockConfig = ref<FromConfig[]>([
  {
    type: "SELECT",
    label: "公司",
    value: "",
    upKey: "companyId",
    rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
    options: companyOptions,
    props: {clearable: true, placeholder: "请选择公司",},
    seleProps: { label: "name", valueName: "id", },
  },
  {
    type: "TIME",
    label: "缴纳日期",
    value: '',
    upKey: 'payDate',
    rule: [{ required: true, message: '请选择缴纳日期', trigger: 'change' }],
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
])
const unlockHandle = async () => {
  unlockConfig.value[0].value = MI_params.companyId
  MI_modifyForm({}, unlockConfig, unlockFg, async (params: any) => {
    await ElMessageBox.confirm( `请确定是否解锁: ${params.payDate} 社保记录`, '提示',{
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
    await socialsUnlock(params)
    ElMessage.success('解锁成功')
    unlockFg.value = false
    searchHd(MI_params)
  })
}

// total 统计
const generateSummary = (param: SummaryMethodProps) => {
  const { columns, data } = param
  const sums: string[] = ['', '合计']
  columns.forEach((column, index) => {
    if (index === 1) return;
    
    const value = totalObj[column.property + 'Total']
    if(typeof value === 'number') {
      sums[index] = getNumber(value)
    } else {
      sums[index] = ''
    }
  })
  sums[18] = getNumber(totalObj['personalTotal'])
  sums[19] = getNumber(totalObj['companyTotal'])
  return sums
}
watch(MI_tableData, (newData) => {
  showTbTotal.value = false
  setTimeout(() => {
    showTbTotal.value = true
  })
})

// 导出社保记录
const epScoialsHisotryHandle = () => {
  if(!MI_params.from || !MI_params.to){
    ElMessage.warning('请先搜索缴纳日期')
    return
  }
  ElMessageBox.confirm(
    `是否导出 ${MI_params.from} 至 ${MI_params.to} 期间数据`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }
  ).then(() => {
    MI_identify.value = true
    return exportHandle(exportScoialsFn, MI_params)
  }).finally(() => {
    MI_identify.value = false
  })
}

// 新增
const isShowAddtion = ref(false)
const addConfig = ref([
  {
    type: 'SELECT',
    label: '员工',
    value: '',
    upKey: 'userId',
    options: userOptions,
    props: {placeholder: '请选择员工',},
    rule: [{ required: true, message: '请选择员工', trigger: 'change' },],
    seleProps: { label: 'name', valueName: 'userId'},
  },
  {
    type: "TIME",
    label: "参保日期",
    value: '',
    upKey: 'participationDate',
    rule: [{ required: true, message: '请选择参保日期', trigger: 'change' }],
  },
  {
    type: "TIME",
    label: "停缴日期",
    value: '',
    upKey: 'unPaymentDate',
  },
  {
    type: 'NUMBER',
    label: '单位养老保险',
    value: 0,
    upKey: 'companyEndowment',
    props: {
      placeholder: "单位养老保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人养老保险',
    value: 0,
    upKey: 'personalEndowment',
    props: {
      placeholder: "个人养老保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位医疗保险',
    value: 0,
    upKey: 'companyMedical',
    props: {
      placeholder: "单位医疗保险",
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人医疗保险',
    value: 0,
    upKey: 'personalMedical',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位工伤保险',
    value: 0,
    upKey: 'companyInjury',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人工伤保险',
    value: 0,
    upKey: 'personalInjury',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位生育保险',
    value: 0,
    upKey: 'companyMaternity',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人生育保险',
    value: 0,
    upKey: 'personalMaternity',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位失业保险',
    value: 0,
    upKey: 'companyUnemployment',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人失业保险',
    value: 0,
    upKey: 'personalUnemployment',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '单位公积金',
    value: 0,
    upKey: 'companyHousing',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: 'NUMBER',
    label: '个人公积金',
    value: 0,
    upKey: 'personalHousing',
    props: {
      type: 'number',
    },
    rule: socialRule,
  },
  {
    type: "TIME",
    label: "缴纳日期",
    value: '',
    upKey: 'payDate',
    props: {
      type: 'month',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    },
    rule: [
      { required: true, message: '请选择缴纳日期', trigger: 'change' },
    ],
  },
  {
    type: "SELECT",
    label: "公司",
    selectType: 'GROUP',
    value: "",
    upKey: "companyId",
    options: store.getters.sysCompany,
    props: {clearable: true, placeholder: "请选择公司"},
    rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
    seleProps: { label: "name", valueName: "id" },
  },
])
const addHandle = () => {
  MI_modifyForm({}, addConfig, isShowAddtion, async (params: any) => {
    await socialsCreateApi(params)
    isShowAddtion.value = false
    ElMessage('新增成功')
    searchHd(MI_params)
  })
}

// 导入社保记录
const importFg = ref<boolean>(false)

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "社保维护" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
            title: true,
            searchConfig: _unref(searchConfig),
            initSearch: true
          }, { onSearchFn: searchHd }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addHandle()))
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    })), [
      [_directive_permission, 'Create']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "danger",
      onClick: delHandle
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })), [
      [_directive_permission, 'Delete']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "info",
      class: "mt-10 mb-10",
      onClick: openLockHandle
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "info",
      class: "mt-10 mb-10",
      onClick: unlockHandle
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    })), [
      [_directive_permission, 'Write']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (epScoialsHisotryHandle())),
      disabled: _unref(MI_identify)
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [_directive_permission, 'Export']
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (importFg.value = true)),
      class: "ml-10"
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    })), [
      [_directive_permission, 'Create']
    ]),
    _createVNode(_component_el_button, {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'insuranceCompare'})))
    }, {
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      border: "",
      ref_key: "insuranceTb",
      ref: insuranceTb,
      data: _unref(MI_tableData),
      "show-summary": showTbTotal.value,
      "summary-method": generateSummary,
      "max-height": _unref(MI_height) + 'px',
      "row-key": 'id',
      onSelectionChange: handleSelectionChange
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          fixed: "",
          "reserve-selection": "",
          selectable: (row, index) => !row.locked 
        }, null, 8, ["selectable"]),
        _createVNode(_component_el_table_column, {
          fixed: "",
          prop: "companyName",
          label: "公司",
          width: "140",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          width: "130",
          fixed: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "participationDate",
          label: "参保日期",
          width: "105"
        }),
        _createVNode(_component_el_table_column, {
          prop: "unPaymentDate",
          label: "停缴日期",
          width: "105"
        }),
        _createVNode(_component_el_table_column, {
          label: "单位养老保险",
          align: "right",
          prop: "companyEndowment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人养老保险",
          align: "right",
          prop: "personalEndowment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位医疗保险",
          align: "right",
          prop: "companyMedical",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人医疗保险",
          align: "right",
          prop: "personalMedical",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位工伤保险",
          align: "right",
          prop: "companyInjury",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人工伤保险",
          align: "right",
          prop: "personalInjury",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位生育保险",
          align: "right",
          prop: "companyMaternity",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人生育保险",
          align: "right",
          prop: "personalMaternity",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位失业保险",
          align: "right",
          prop: "companyUnemployment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人失业保险",
          align: "right",
          prop: "personalUnemployment",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位公积金",
          align: "right",
          prop: "companyHousing",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "个人公积金",
          align: "right",
          prop: "personalHousing",
          width: "120",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "缴纳时间",
          prop: "payDate",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "个人社保总计",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "personalTotal",
          width: "110",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "单位社保总计",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "companyTotal",
          width: "110",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "总计",
          align: "right",
          formatter: _unref(formatNumber),
          prop: "social",
          width: "110",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "95"
        }, {
          default: _withCtx(({ row }) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
              onClick: ($event: any) => (showEdit(row)),
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, 'Write']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_link, {
              onClick: ($event: any) => (lockRowHandle(row)),
              class: "ml-10"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_permission, 'Write']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "show-summary", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : page = $event)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "社保编辑",
      modelValue: socialsVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((socialsVisible).value = $event)),
      width: "880px",
      draggable: ""
    }, {
      default: _withCtx(() => [
        (socialsVisible.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref_key: "editEle",
              ref: editEle
            }, {
          searchConfig: _unref(modifyConfig),
          submitText: '确定'
        }), {
              BefaultBtnGroup: _withCtx(() => [
                _createVNode(_component_el_button, { onClick: proposalHandle }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: lockFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((lockFg).value = $event)),
      draggable: "",
      width: "600px",
      title: "锁定"
    }, {
      default: _withCtx(() => [
        (lockFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: lockConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: unlockFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((unlockFg).value = $event)),
      title: "解锁",
      draggable: "",
      width: "600px"
    }, {
      default: _withCtx(() => [
        (unlockFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: unlockConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "新增社保",
      draggable: "",
      modelValue: isShowAddtion.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isShowAddtion).value = $event)),
      width: "880px"
    }, {
      default: _withCtx(() => [
        (isShowAddtion.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: importFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((importFg).value = $event)),
      draggable: "",
      width: "650px",
      title: "导入社保记录"
    }, {
      default: _withCtx(() => [
        _createVNode(eptBtn, {
          type: "primary",
          exportFn: _unref(socialsDownloadSocialApi),
          exportText: '下载社保记录标准模板',
          isDirect: true
        }, null, 8, ["exportFn"]),
        _createVNode(eptBtn, {
          type: "warning",
          exportFn: _unref(socialsDownloadSocial_templateApi),
          exportText: '下载湖南社保模板',
          isDirect: true
        }, null, 8, ["exportFn"]),
        _createVNode(eptBtn, {
          type: "warning",
          exportFn: _unref(SocialsDownloadFund_templateApi),
          exportText: '下载湖南公积金模板',
          isDirect: true
        }, null, 8, ["exportFn"]),
        _createVNode(_component_el_divider),
        _withDirectives(_createVNode(_component_TheUpBtn, {
          upText: '导入标准模板',
          upFetch: _unref(socialsUploadApi),
          upParams: {},
          showBtn: true
        }, null, 8, ["upFetch"]), [
          [_directive_permission, 'Create']
        ]),
        _withDirectives(_createVNode(_component_TheUpBtn, {
          class: "ml-10",
          upText: '导入湖南模板',
          upFetch: _unref(socialsImportApi),
          upConfig: [{
          type: 'SELECT',
          label: '公司',
          value: '',
          upKey: 'companyId',
          options: _unref(companyOptions),
          rule: [{ required: true, message: '请选择公司', trigger: 'change' }],
          props: {clearable: true, placeholder: '请选择公司'},
          seleProps: { label: 'name', valueName: 'id', },
        }],
          upParams: {},
          showBtn: true
        }, null, 8, ["upFetch", "upConfig"]), [
          [_directive_permission, 'Create']
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})